
import store from './../../store';
import Vue from 'vue';

const success = (data, resolve) => {
  const appVersionData = data;
  store.dispatch('fetchLatestVersion', appVersionData);
  resolve();
};

const failed = (error, reject) => reject(error);

export default () => (
  new Promise((resolve, reject) => {
    Vue.$http.get('user-app-version')
    .then((response) => {
      success(response, resolve);
    })
    .catch((error) => {
      failed(error, reject);
    });
  })
);



// WEBPACK FOOTER //
// ./src/app/services/account/fetchUserAppVersion.js